import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import Layout from '../../wrappers/layout';
import IndicatorCard from './components/indicator-card';
import BuySellMetals from './components/buy-sell-metals';
import DashboardBanner from './components/dashboard-banner';
import PageHeader from '../../shared/page-header';
import { dashboardStore } from '../../store/DashboardStore';
import { userStore } from '../../store/UserStore';
import DashboardService from '../../services/dashboard.service';
import RealisedService from '../../services/realised.service';
import Loader from '../../shared/common/loader';
import Banner1 from '../../assets/images/banner1.png';
import Banner2 from '../../assets/images/banner.jpg';
import { formatAmount } from '../../utils';
import NomineeModal from 'pages/profile/components/NomineeModal';
import Pushnotification from '../login/services/login.service';
import { getMessaging, getToken } from 'firebase/messaging';
import { app, db, auth } from '../../firebaseConfig';
import RedeemGiftModal from 'pages/gift-module/RedeemGiftModal';
import { useHistory, useLocation } from 'react-router-dom';
import SupportButton from 'shared/common/supportButton/SupportButton';
// import SupportButton from 'shared/common/supportButton/SupportButton';
import downArrow from 'assets/icons/chevron-down.svg';
import upArrow from 'assets/icons/chevron-up.svg';
import { toast } from 'react-toastify';
import './index.css';
import GiftModal from 'pages/Corporate-gifting/GiftModal';
import giftService from 'pages/gift-module/services/gift.service';
import SuccessGiftModal from 'pages/Corporate-gifting/SuccessGiftModal';
import KycFraudModal from 'shared/common/modal/kycFraudModal';
const metalsWithCode = [
  { code: 'Au', name: 'Gold' },
  { code: 'Ag', name: 'Silver' },
  { code: 'Pt', name: 'Platinum' },
  { code: 'Pd', name: 'Palladium' },
];

interface PropsType { }

const DashboardPage: React.FC<PropsType> = () => {
  const renderCheck = useRef(false);
  // eslint-disable-next-line
  const [
    customerHolding,
    wallet,
    summary,
    accountsHolding,
    metals,
    setCustomerHolding,
    setAccountHolding,
    setWallet,
    setSummary,
    setMetals,
  ] = dashboardStore((state: any) => [
    state.customerHolding,
    state.wallet,
    state.summary,
    state.accountsHolding,
    state.metals,
    state.setCustomerHolding,
    state.setAccountHolding,
    state.setWallet,
    state.setSummary,
    state.setMetals,
  ]);
  const [customerId, user, selectedAccount, customer] = userStore(
    (state: any) => [
      state.customerId,
      state.user,
      state.selectedAccount,
      state.customer,
    ]
  );

  // const metalObj = ['Ag', 'Pd', 'Pt', 'Au'];
  const [loading, setLoading] = useState<boolean>(false);
  const [realisedLoading, setRealisedLoading] = useState<boolean>(false);
  const [holdings, setHoldings] = useState([]);
  const [open, setOpen] = useState<any>(false);
  const [realisedData, setRealisedData] = useState<any>();
  const [unRealisedData, setUnRealisedData] = useState<any>();
  const [showBankDetailsModal, setShowBankDetailsModal] = useState(false);
  let arrayOfObjects;
  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const gift = searchParams.get('gift');

  // Corporate Gifting
  const [showCorpGiftModal, setShowCorpGiftModal] = useState(false);
  const [showCorpSuccessModal, setShowCorpSuccessModal] = useState(false);
  const [voucherCode, setVoucherCode] = useState('');
  const [corpGiftMessage, setCorpGiftMessage] = useState('');

  // KYC for fraud
  const location: any = useLocation();
  const [isKycFRequired, setIsKycFRequired] = useState(false);
  const [kycError, setKycError] = useState('');

  const [checkRedirecting, setCheckRedirecting] = useState(true);

  useEffect(() => {
    const isKycRequiredDash = location.state?.isKycRequired || false;
    const KycErrorDash = location.state?.kycError || '';
    if (isKycRequiredDash) {
      setIsKycFRequired(true);
      setKycError(KycErrorDash);
    }
  }, []);

  const KycFraudCompleteFunction = async () => {
    try {
      const res = await DashboardService.isKYCFraudComplete();
      if (!res?.data?.kyc_completed) {
        // Adjust based on actual response structure
        setIsKycFRequired(true);
        setKycError(res?.data?.kyc_error);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong');
    }
  };

  const images = [
    { src: Banner1, alt: 'Banner1' },
    // { src: Banner2, alt: "Banner2" },
    // Add more images as needed
  ];

  const isValidGiftCode = async (code: any) => {
    try {
      const data = {
        voucherCode: code,
      };
      const res = await giftService.isValidGiftCode(data);
      console.log(res.data.data.GiftMessage);
      setCorpGiftMessage(res.data.data.GiftMessage);
      if (res.data.data.isValid) {
        setShowCorpGiftModal(true);
      } else {
        toast.error('Invalid Voucher Code!');
      }
    } catch (err) {
      toast.error('Something went wrong');
      console.log(err);
    }
  };

  const claimCorporateGift = async () => {
    try {
      const data = {
        corpVoucherId: voucherCode,
        partnerId: customer?.partner?.id,
      };
      setLoading(true);
      const res = await giftService.acceptCorporateGift(data);
      if (res.status == 201 && res.data.data.message == 'success') {
        setLoading(false);
        setShowCorpGiftModal(false);
        toast.success('Gift Claimed Successfully!');
        setShowCorpSuccessModal(true);
        getPassbookSummary();
      } else {
        setLoading(false);
        toast.error('Something went wrong!');
        setShowCorpGiftModal(false);
      }
    } catch (err: any) {
      console.log(err);
      setLoading(false);
      toast.error('Invalid Voucher Code');
      setShowCorpGiftModal(false);
    }
  };

  const redirectToPassbook = () => {
    history.push('/buy-sell');
  };

  const closeGiftModal = () => {
    setShowCorpGiftModal(false);
  };
  const closeGiftSuccessModal = () => {
    setShowCorpSuccessModal(false);
  };
  // end Corporate Gifting

  const ecom = searchParams.get('ecom');
  const decodedecom = JSON.parse(decodeURIComponent(ecom));
  // const decodedMetal = gift ? decodeURIComponent(gift) : ((decodedecom ? decodedecom.metalType) : undefined);
  const decodedMetal = gift
    ? decodeURIComponent(gift)
    : decodedecom
      ? decodedecom.metalType
      : undefined;
  useEffect(() => {
    if (selectedAccount) {
      let acHoldings = accountsHolding.find(
        (acc) => acc.accountId === selectedAccount.accountId
      );
      if (acHoldings) setHoldings(acHoldings.accountHolding);
    }
  }, [accountsHolding, selectedAccount]);

  useEffect((): any => {
    getPassbookSummary();
    getAllMetals();
    storeFCMToken();
    document.title = 'Dashboard - eBullion';
  }, []);

  useEffect(() => {
    if (renderCheck.current) {
      getPassbookSummary();
      getAllMetals();
    } else {
      renderCheck.current = true;
    }
  }, [customerId]);

  const handleBannerClick = () => {
    history.push('/sip');
  };

  /**
   * Get passbook summary details
   */
  const getPassbookSummary = async () => {
    setLoading(true);
    try {
      const res: any = await DashboardService.getPassbookSummary(
        customerId,
        user?.userId
      );
      if (res.status === 200 && res.data.data) {
        setCustomerHolding(
          res.data.data.metal.customerHolding.sort((a: any, b: any) =>
            a.metal.localeCompare(b.metal)
          )
        );
        setAccountHolding(res.data.data.metal.accountsHolding);
        setWallet(res.data.data.wallet);
        setSummary(res.data.data.summary);

        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  /**
   * Get all metals
   */
  const getAllMetals = async () => {
    setLoading(true);
    try {
      const res: any = await DashboardService.getAllMetals();
      if (res.status === 200 && res.data.data.result.length > 0) {
        setMetals(res.data.data.result);
        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  const storeFCMToken = async () => {
    try {
      const messaging = getMessaging(app);
      const userId = user?.customers[0]?.user?.userId;

      // Retrieve the FCM token
      getToken(messaging)
        .then(async (token) => {
          const data = { webtoken: token, user_id: userId };
          const storeToken = await Pushnotification.storeFcmToken(data);
          // console.log('FCM Token:', token);
        })
        .catch((error) => {
          console.error('Error getting FCM token:', error);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const claimGift = () => {
    history.push('/gift?giftListReceived=true');
  };
  const onCancel = () => {
    localStorage.setItem('popupGiftShown', 'true');

    setOpen(false);
  };

  // realised data
  const profitLoss = async () => {
    try {
      const data = { customerId: customerId };
      setRealisedLoading(true);
      const res = await RealisedService.realisedData(
        data,
        user?.userId,
        user?.partner?.id
      );
      if (res.status == 200) {
        const newdata: Object = res.data.data.Realised;
        // arrayOfObjects = Object.entries(newdata).map(([key, value]) => ({
        //   metal: key,
        //   ...value,
        // }));
        setRealisedData(res?.data?.data?.Realised);
        setUnRealisedData(res?.data?.data?.Unrealised);
        setRealisedLoading(false);

        // console.log('realiseddata', arrayOfObjects);
      } else {
        // setRealisedLoading(false);

        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      setRealisedLoading(false);

      toast.error('Something went wrong');
    }
  };
  useEffect(() => {
    profitLoss();
    const hasPopupBeenShown = localStorage.getItem('popupGiftShown');
    if (
      !hasPopupBeenShown &&
      customer?.giftCount > 0 &&
      customer?.customerCategory === 'UNREGISTERED'
    ) {
      setOpen(true);
      localStorage.setItem('popupGiftShown', 'true');
    }
  }, []);

  const investedMetalSum =
    realisedData &&
    Object.keys(realisedData)?.reduce(
      (acc, metal) => acc + realisedData[metal]?.sell_price,
      0
    );
  const markToMarkSum =
    unRealisedData &&
    Object.keys(unRealisedData)?.reduce(
      (acc, metal) => acc + unRealisedData[metal].totalSellAmount,
      0
    );
  const unInvestedSum =
    unRealisedData &&
    Object.keys(unRealisedData)?.reduce(
      (acc, metal) => acc + unRealisedData[metal].totalBuybackAmount,
      0
    );

  const realisedMetalSum =
    realisedData &&
    Object.keys(realisedData)?.reduce(
      (acc, metal) => acc + realisedData[metal]?.buyback_price,
      0
    );

  const realisedPLSum = realisedMetalSum - investedMetalSum;
  const unrealisedPLSum = markToMarkSum - unInvestedSum;
  const realisedPLSumPer =
    investedMetalSum > 0
      ? ((realisedMetalSum - investedMetalSum) / investedMetalSum) * 100
      : realisedMetalSum > 0
        ? 100
        : 0;
  const unrealisedPLSumPer =
    unInvestedSum > 0
      ? ((markToMarkSum - unInvestedSum) / unInvestedSum) * 100
      : markToMarkSum > 0
        ? 100
        : 0;

  useEffect(() => {
    const sipLSdata = localStorage.getItem('sipdata');
    if (sipLSdata !== null) {
      history.push({
        pathname: '/sip',
        state: { sipdata: JSON.parse(sipLSdata) },
      });
    }

    const manualSipLSdata = localStorage.getItem('manualSipData');
    if (manualSipLSdata !== null) {
      const manualSipObj = JSON.parse(manualSipLSdata);
      const manualSipEncObj = encodeURIComponent(manualSipLSdata);

      let redirectUrl = `/sip-payment-schedule/${manualSipObj?.sipId}?data=${manualSipEncObj}`;
      history.push(redirectUrl);
    }

    const productLSdata = localStorage.getItem('Product');
    if (productLSdata !== null) {
      history.push({
        pathname: '/buy-coins-bars',
      });
    } else {
      setCheckRedirecting(false);
    }
  }, []);

  useEffect(() => {
    const corpGiftVoucher = localStorage.getItem('corpVoucherCode');
    if (corpGiftVoucher) {
      isValidGiftCode(corpGiftVoucher);
      setVoucherCode(corpGiftVoucher);
      localStorage.removeItem('corpVoucherCode');
    }
  }, []);


  useEffect(() => {
    if (loading) return;

    const alreadyShownThisSession = sessionStorage.getItem('bankDetailsModalShown');
    if (alreadyShownThisSession) return; // ← skip if already shown

    const isBankDetailsMissing =
      !customer?.bankDetails?.accountNo ||
      customer?.bankDetails?.state !== 'VERIFIED';

    const hasSignificantHoldings = summary?.metalBalance > 100;

    if (isBankDetailsMissing && hasSignificantHoldings) {
      const timer = setTimeout(() => {
        setShowBankDetailsModal(true);
        sessionStorage.setItem('bankDetailsModalShown', 'true'); // ← mark as shown
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [loading, summary?.metalBalance, customer?.bankDetails]);

  if (checkRedirecting) {
    return <></>;
  }


  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <div>
          {/*<Toast/>*/}
          <PageHeader
            mainTitle={user.displayName}
            subTitle='Below are your total holdings'
          />

          <Row>
            <Col md={8}>
              <DashboardBanner images={images} onClick={handleBannerClick} />
              <Row>
                <Col md={6}>
                  <div className='my-1 col col-sm-12 '>
                    <IndicatorCard
                      isMain
                      heading={
                        <span className="metal-heading">
                          Metal Holdings
                          <span className="metal-note">
                            * (As per current market rates)
                          </span>
                        </span>
                      }
                      amount={`₹ ${formatAmount(summary.metalBalance) || '0.00'
                        }`}
                      backgroundColor='#301250'
                      addClassName='py-2 tot-card'
                      styles=''
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='my-1 col col-sm-12 '>
                    <IndicatorCard
                      isMain
                      heading='In Wallet'
                      amount={`₹ ${formatAmount(wallet.balance)}` || '0.00'}
                      styles=''
                      addClassName='wallet '
                      earmarkedBalance={`₹ ${formatAmount(wallet.lockBalance)}`}
                    />
                  </div>
                </Col>
              </Row>
              {/*<div>*/}
              {/*<div className="my-1 col col-sm-12 col-md-4">*/}
              {/*  <IndicatorCard*/}
              {/*      isMain*/}
              {/*      heading="Total Holdings"*/}
              {/*      amount={`₹ ${formatAmount(summary.walletBalance + summary.metalBalance) || '0.00'}`}*/}
              {/*      backgroundColor="#301250"*/}
              {/*      addClassName="h-100 tot-card"*/}
              {/*      styles=""*/}
              {/*  />*/}
              {/*</div>*/}
              {/*<div className="my-1 col col-sm-12 col-md-4">*/}
              {/*  <IndicatorCard*/}
              {/*      isMain*/}
              {/*      heading="In Wallet"*/}
              {/*      amount={`₹ ${formatAmount(wallet.balance)}` || '0.00'}*/}
              {/*      styles=""*/}
              {/*      addClassName="wallet "*/}
              {/*      earmarkedBalance={`₹ ${formatAmount(wallet.lockBalance)}`}*/}
              {/*  />*/}
              {/*</div>*/}
              {/*</div>*/}
              <div className='col-md-8 overflow-auto d-sm-block d-md-none'>
                <div className='d-flex flex-column bd-highlight'>
                  {holdings?.map((account: any, index: number) => (
                    <div key={index} className='mb-2 flex-fill flex-shrink-0'>
                      <div key={index} className=''>
                        <IndicatorCard
                          // eslint-disable-next-line react/no-array-index-key
                          isMain={false}
                          heading={
                            metalsWithCode.filter(
                              (x: any) => x.code === account.metal
                            ).length > 0
                              ? metalsWithCode.filter(
                                (x: any) => x.code === account.metal
                              )[0].name
                              : ''
                          }
                          amount={`₹ ${formatAmount(account.value) || ' 0.00'}`}
                          quantity={`${account.quantity?.toFixed(4)}`}
                          addClassName={`${account.metal} metal mobileCard`}
                          earmarkedBalance={account.lockQuantity || ''}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className='d-md-grid grid d-sm-flex mt-2 d-none d-sm-block'>
                {holdings?.map((account: any, index: number) => (
                  <div key={index}>
                    <IndicatorCard
                      // eslint-disable-next-line react/no-array-index-key
                      isMain={false}
                      heading={
                        metalsWithCode.filter(
                          (x: any) => x.code === account.metal
                        ).length > 0
                          ? metalsWithCode.filter(
                            (x: any) => x.code === account.metal
                          )[0].name
                          : ''
                      }
                      metalCode={account.metal}
                      redirectLink={`/passbook?metalCode=${account.metal}`}
                      amount={`₹ ${formatAmount(account.value) || ' 0.00'}`}
                      quantity={`${account.quantity?.toFixed(4)}`}
                      addClassName={`${account.metal} metal`}
                      earmarkedBalance={account.lockQuantity || ''}
                    />
                  </div>
                ))}
                {customerHolding && customerHolding.length === 0 ? (
                  <>
                    {[1, 2, 3, 4].map((item: any, index: number) => (
                      <div key={index}>
                        <IndicatorCard
                          // eslint-disable-next-line react/no-array-index-key
                          isMain={false}
                          heading={null}
                          amount={null}
                          quantity={null}
                          addClassName={` metal`}
                          earmarkedBalance={null}
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Col>
            <Col md={4}>
              <BuySellMetals
                metals={metals}
                walletBalance={summary.walletBalance}
                isDashboard={true}
                getPassbookSummary={getPassbookSummary}
                giftMetal={decodedMetal}
                KycFraudCompleteFunction={KycFraudCompleteFunction}
              />
            </Col>
          </Row>
          <SupportButton />
          <Row className='mt-5 mb-3'>
            {realisedLoading ? (
              // <Spinner animation='border' variant='primary' role='status'>
              //   {/* <span className='visually-hidden'>Loading...</span> */}
              // </Spinner>
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                Loading...
              </span>
            ) : (
              realisedData && (
                <>
                  <Col md={6}>
                    <h5>BOOKED GAIN / LOSS</h5>
                    <div className='table-real-container overflow-auto'>
                      <table className='custom-table' style={{ height: 300 }}>
                        <thead>
                          <tr>
                            <th className='center-align'>Metal</th>
                            {realisedData &&
                              Object.keys(realisedData).map((metalCode) => {
                                const metalObject = metalsWithCode?.find(
                                  (metal) => metal?.code === metalCode
                                );
                                const metalName = metalObject
                                  ? metalObject?.name
                                  : metalCode;
                                return (
                                  <th key={metalCode} className='center-align'>
                                    {metalName}
                                  </th>
                                );
                              })}
                            <th className='center-align'>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr>
                            <td className='left-align'>
                              <b>Invested Metal Value</b>
                            </td>
                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-sold`}
                                  className='right-align'
                                >
                                  ₹{realisedData[metal].sell_price.toFixed(2)}
                                </td>
                              ))}
                          </tr> */}

                          <tr>
                            <td className='left-align'>
                              <b>Invested Metal Value</b>
                            </td>
                            {Object.keys(realisedData).map((metal) => (
                              <td key={`${metal}-sold`} className='right-align'>
                                ₹{realisedData[metal].sell_price.toFixed(2)}
                              </td>
                            ))}
                            <td className='right-align'>
                              ₹{investedMetalSum.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className='left-align'>
                              <b>Realised Metal Value</b>
                            </td>

                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-investment`}
                                  className='right-align'
                                >
                                  ₹
                                  {realisedData[metal].buyback_price.toFixed(2)}
                                </td>
                              ))}
                            <td className='right-align'>
                              ₹{realisedMetalSum.toFixed(2)}
                            </td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Metal Transacted</b>
                            </td>
                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-invst`}
                                  className='right-align'
                                >
                                  {realisedData[metal].quantity.toFixed(4)} g
                                </td>
                              ))}
                            <td className='center-align'>-</td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Gain / Loss (INR)</b>
                            </td>
                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-pp`}
                                  className='right-align'
                                  style={{ padding: '5px' }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    {realisedData[metal].buyback_price.toFixed(
                                      2
                                    ) -
                                      realisedData[metal].sell_price.toFixed(
                                        2
                                      ) !=
                                      0 ? (
                                      realisedData[metal].buyback_price.toFixed(
                                        2
                                      ) -
                                        realisedData[metal].sell_price.toFixed(
                                          2
                                        ) >
                                        0 ? (
                                        <img
                                          src={upArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={downArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      )
                                    ) : (
                                      ''
                                    )}
                                    <span>
                                      ₹
                                      {Math.abs(
                                        realisedData[metal].buyback_price -
                                        realisedData[metal].sell_price
                                      ).toFixed(2)}
                                    </span>
                                  </div>
                                </td>
                              ))}
                            <td
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {realisedPLSum != 0 ? (
                                  realisedPLSum > 0 ? (
                                    <img
                                      src={upArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  )
                                ) : (
                                  ''
                                )}
                                <span>
                                  ₹{Math.abs(realisedPLSum).toFixed(2)}
                                </span>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Gain / Loss (%)</b>
                            </td>
                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-pp`}
                                  className='right-align'
                                  style={{ padding: '5px' }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    {realisedData[metal].buyback_price.toFixed(
                                      2
                                    ) -
                                      realisedData[metal].sell_price.toFixed(
                                        2
                                      ) !=
                                      0 ? (
                                      realisedData[metal].buyback_price.toFixed(
                                        2
                                      ) -
                                        realisedData[metal].sell_price.toFixed(
                                          2
                                        ) >
                                        0 ? (
                                        <img
                                          src={upArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={downArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      )
                                    ) : (
                                      ''
                                    )}
                                    <span>
                                      {realisedData[metal].sell_price > 0
                                        ? Math.abs(
                                          ((realisedData[metal]
                                            .buyback_price -
                                            realisedData[metal].sell_price) /
                                            realisedData[metal].sell_price) *
                                          100
                                        ).toFixed(2)
                                        : realisedData[metal].buyback_price > 0
                                          ? 100
                                          : 0}
                                      %
                                    </span>
                                  </div>
                                </td>
                              ))}

                            <td
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {realisedPLSumPer !== 0 ? (
                                  <>
                                    {realisedPLSumPer > 0 ? (
                                      <img
                                        src={upArrow}
                                        className='arrow-icon'
                                        style={{
                                          marginRight: '5px',
                                          marginBottom: '-4px',
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={downArrow}
                                        className='arrow-icon'
                                        style={{
                                          marginRight: '5px',
                                          marginBottom: '-4px',
                                        }}
                                      />
                                    )}
                                  </>
                                ) : (
                                  ''
                                )}
                                <span>
                                  {realisedPLSumPer !== 0
                                    ? Math.abs(realisedPLSumPer).toFixed(2)
                                    : 0}
                                  %
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                  <Col md={6} className='mob-table-margin'>
                    <h5>POTENTIAL GAIN / LOSS</h5>
                    <div className='table-real-container overflow-auto'>
                      <table className='custom-table' style={{ height: 300 }}>
                        {/* <table className='custom-table' > */}
                        <thead>
                          <tr>
                            <th className='center-align'>Metal</th>
                            {realisedData &&
                              Object.keys(realisedData).map((metalCode) => {
                                const metalObject = metalsWithCode.find(
                                  (metal) => metal.code === metalCode
                                );
                                const metalName = metalObject
                                  ? metalObject.name
                                  : metalCode;
                                return (
                                  <th key={metalCode} className='center-align'>
                                    {metalName}
                                  </th>
                                );
                              })}
                            <th className='center-align'>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className='left-align'>
                              <b>Investment value</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-invst`}
                                  className='right-align'
                                >
                                  ₹
                                  {unRealisedData[
                                    metal
                                  ].totalBuybackAmount.toFixed(2)}
                                </td>
                              ))}
                            <td className='right-align'>
                              ₹{Math.abs(unInvestedSum).toFixed(2)}
                            </td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Mark to Market value</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-invst`}
                                  className='right-align'
                                >
                                  ₹
                                  {unRealisedData[
                                    metal
                                  ].totalSellAmount.toFixed(2)}
                                </td>
                              ))}
                            <td className='right-align'>
                              ₹{Math.abs(markToMarkSum).toFixed(2)}
                            </td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Metal Holdings</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-invst`}
                                  className='right-align'
                                >
                                  {unRealisedData[
                                    metal
                                  ].totalSellQuantity.toFixed(4)}
                                  g
                                </td>
                              ))}
                            <td className='center-align'>-</td>
                          </tr>

                          {/* <tr>
                      <td>
                        <b>Balance Metal</b>
                      </td>
                      {unRealisedData &&
                        Object.keys(unRealisedData).map((metal) => (
                          <td key={`${metal}-invst`}>
                            ₹{unRealisedData[metal].finalAmount.toFixed(2)}
                          </td>
                        ))}
                    </tr> */}
                          {/* <tr>
                          <td className="left-align">
                            <b>Gain / Loss (INR)</b>
                          </td>
                          {/* {unRealisedData &&
                        Object.keys(unRealisedData).map((metal) => (
                          <td key={`${metal}-pp`}>
                            {unRealisedData[metal].totalBuybackAmount +
                              unRealisedData[metal].finalAmount -
                              unRealisedData[metal].totalSellAmount >
                            0 ? (
                              <img
                                src={upArrow}
                                style={{ marginRight: '5px' }}
                              />
                            ) : (
                              <img
                                src={downArrow}
                                style={{ marginRight: '5px' }}
                              />
                            )}
                            ₹
                            {Math.abs(
                              unRealisedData[metal].totalBuybackAmount +
                                unRealisedData[metal].finalAmount -
                                unRealisedData[metal].totalSellAmount
                            ).toFixed(2)}
                          </td>
                        ))} */}
                          {/* {unRealisedData &&
                          Object.keys(unRealisedData).map((metal) => (
                            <td
                              key={`${metal}-pp`}
                              style={{ padding: '5px' }}
                              className="right-align"
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',

                                }}
                                className="right-align"
                              >
                                {unRealisedData[metal].totalSellAmount -
                                  unRealisedData[metal].totalBuybackAmount >
                                  0 ? (
                                  <img
                                    src={upArrow}
                                    style={{
                                      marginRight: '5px',
                                      marginBottom: '-4px',
                                    }}
                                    className="right-align"
                                  />
                                ) : (
                                  <img
                                    src={downArrow}
                                    style={{
                                      marginRight: '5px',
                                      marginBottom: '-4px',
                                    }}
                                    className="right-align"
                                  />
                                )}
                                <span className="right-align">
                                  ₹
                                  {Math.abs(
                                    unRealisedData[metal].totalSellAmount -
                                    unRealisedData[metal].totalBuybackAmount
                                  ).toFixed(2)}
                                </span>
                              </div>
                            </td>
                          ))} */}
                          {/* </tr> */}

                          <tr>
                            <td className='left-align'>
                              <b>Gain / Loss (INR)</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-pp`}
                                  style={{ padding: '5px' }}
                                  className='right-align'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    {unRealisedData[metal].totalSellAmount -
                                      unRealisedData[metal]
                                        .totalBuybackAmount !=
                                      0 ? (
                                      unRealisedData[metal].totalSellAmount -
                                        unRealisedData[metal]
                                          .totalBuybackAmount >
                                        0 ? (
                                        <img
                                          src={upArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={downArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      )
                                    ) : (
                                      ''
                                    )}
                                    <span>
                                      ₹
                                      {Math.abs(
                                        unRealisedData[metal].totalSellAmount -
                                        unRealisedData[metal]
                                          .totalBuybackAmount
                                      ).toFixed(2)}
                                    </span>
                                  </div>
                                </td>
                              ))}
                            <td
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {unrealisedPLSum != 0 ? (
                                  unrealisedPLSum > 0 ? (
                                    <img
                                      src={upArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  )
                                ) : (
                                  ''
                                )}
                                <span>
                                  ₹{Math.abs(unrealisedPLSum).toFixed(2)}
                                </span>
                              </div>
                            </td>
                          </tr>

                          {/* <tr>
                          <td className='left-align'>
                            <b>Gain / Loss (%)</b>
                          </td>
                          {unRealisedData &&
                            Object.keys(unRealisedData).map((metal) => (
                              <td
                                key={`${metal}-pp`}
                                style={{ padding: '5px' }}
                                className="right-align"
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                  className="right-align"
                                >
                                  {unRealisedData[
                                    metal
                                  ].totalSellAmount.toFixed(2) -
                                    unRealisedData[
                                      metal
                                    ].totalBuybackAmount.toFixed(2) >
                                    0 ? (
                                    <img
                                      src={upArrow}
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                      className="right-align"
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                      className="right-align"
                                    />
                                  )}
                                  <span className="right-align">
                                    {unRealisedData[metal].totalBuybackAmount >
                                      0
                                      ? Math.abs(
                                        ((unRealisedData[metal]
                                          .totalSellAmount -
                                          unRealisedData[metal]
                                            .totalBuybackAmount) /
                                          unRealisedData[metal]
                                            .totalBuybackAmount) *
                                        100
                                      ).toFixed(2)
                                      : 0}
                                    %
                                  </span>
                                </div>
                              </td>
                            ))}

                          {/* <td>
                      <img src={downArrow} style={{ marginRight: '5px' }} />
                      ₹200.00
                    </td> */}
                          {/* </tr> */}

                          <tr>
                            <td className='left-align'>
                              <b>Gain / Loss (%)</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-pp`}
                                  style={{ padding: '5px' }}
                                  className='right-align'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    {unRealisedData[
                                      metal
                                    ].totalSellAmount.toFixed(2) -
                                      unRealisedData[
                                        metal
                                      ].totalBuybackAmount.toFixed(2) !=
                                      0 ? (
                                      unRealisedData[
                                        metal
                                      ].totalSellAmount.toFixed(2) -
                                        unRealisedData[
                                          metal
                                        ].totalBuybackAmount.toFixed(2) >
                                        0 ? (
                                        <img
                                          src={upArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={downArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      )
                                    ) : (
                                      ''
                                    )}
                                    <span className='right-align'>
                                      {unRealisedData[metal]
                                        .totalBuybackAmount > 0
                                        ? Math.abs(
                                          ((unRealisedData[metal]
                                            .totalSellAmount -
                                            unRealisedData[metal]
                                              .totalBuybackAmount) /
                                            unRealisedData[metal]
                                              .totalBuybackAmount) *
                                          100
                                        ).toFixed(2)
                                        : unRealisedData[metal]
                                          .totalSellAmount > 0
                                          ? 100
                                          : 0}
                                      %
                                    </span>
                                  </div>
                                </td>
                              ))}
                            {/* <td className='center-align'>-</td> */}
                            <td
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {unrealisedPLSumPer !== 0 ? (
                                  <>
                                    {unrealisedPLSumPer > 0 ? (
                                      <img
                                        src={upArrow}
                                        className='arrow-icon'
                                        style={{
                                          marginRight: '5px',
                                          marginBottom: '-4px',
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={downArrow}
                                        className='arrow-icon'
                                        style={{
                                          marginRight: '5px',
                                          marginBottom: '-4px',
                                        }}
                                      />
                                    )}
                                  </>
                                ) : (
                                  ''
                                )}
                                <span>
                                  {unrealisedPLSumPer !== 0
                                    ? Math.abs(unrealisedPLSumPer).toFixed(2)
                                    : 0}
                                  %
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                  <div
                    className='mt-2 text-center'
                    style={{ fontSize: '14px', color: '#99834d' }}
                  >
                    *Note: Gifts are currently displayed as an investment by the
                    sender, resulting in a deficit for the sender, and as a
                    gains for the recipient.
                  </div>
                </>
              )
            )}
          </Row>

          {/* <SupportButton /> */}
        </div>
      )}
      {/* {customer.customerCategory === 'UNREGISTERED' &&
        customer?.nomineeDetails?.length < 1 && <NomineeModal />} */}
      {customer.giftCount > 0 &&
        customer?.customerCategory === 'UNREGISTERED' &&
        !showCorpGiftModal &&
        !showCorpSuccessModal && ( // Ensure RedeemGiftModal doesn't show if other modals are open
          <RedeemGiftModal
            showModal={open}
            closeModal={() => {
              setOpen(false); // Ensure modal is properly closed
              closeGiftModal(); // Close any other modals if needed
            }}
            proceed={claimGift}
            cancel={onCancel}
            text={`
        You have received a gift🎁
        To claim it, please go to Gift Page.
        Thank you!
      `}
            keytext={'gift'}
            okButton={'Go to Gift'}
            cancelButton={'Later'}
            title={'Your Gift Awaits!'}
          />
        )}

      {/* <NomineeModal /> */}

      <GiftModal
        showModal={showCorpGiftModal}
        closeModal={() => {
          closeGiftModal(); // Close GiftModal
          setOpen(false); // Ensure RedeemGiftModal stays closed
        }}
        cancel={closeGiftModal}
        proceed={claimCorporateGift}
        corpGiftMessage={corpGiftMessage}
      />

      <SuccessGiftModal
        showModal={showCorpSuccessModal}
        cancel={() => {
          closeGiftSuccessModal(); // Close SuccessGiftModal
          setOpen(false); // Ensure RedeemGiftModal stays closed
        }}
        proceed={redirectToPassbook}
      />

      <KycFraudModal
        showModal={isKycFRequired}
        closeModal={() => {
          setIsKycFRequired(false); // Ensure modal is properly closed
          closeGiftModal(); // Close any other modals if needed
        }}
        text={kycError}
        title={'KYC Required!'}
      />

      {showBankDetailsModal && (
        <div
          style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <div
            style={{
              background: '#fff', borderRadius: '12px', padding: '32px 28px',
              maxWidth: '420px', width: '90%', textAlign: 'center',
              boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            }}
          >
            <div style={{ fontSize: '40px', marginBottom: '12px' }}>🏦</div>
            {/* <h5 style={{ fontWeight: 700, marginBottom: '10px', color: '#301250' }}>
        Bank Details Missing
      </h5> */}
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '24px' }}>
              You're almost set! Please verify your bank details to enjoy seamless investments and transactions.
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={() => setShowBankDetailsModal(false)}
                style={{
                  padding: '10px 20px', borderRadius: '8px', border: '1px solid #ccc',
                  background: '#fff', cursor: 'pointer', fontSize: '14px', color: '#666',
                }}
              >
                Later
              </button>
              <button
                onClick={() => {
                  setShowBankDetailsModal(false);
                  history.push('/profile?bank=true'); // matches profile page: bank=true → bankDetails tab
                }}
                style={{
                  padding: '10px 24px', borderRadius: '8px', border: 'none',
                  background: '#301250', color: '#fff', cursor: 'pointer',
                  fontSize: '14px', fontWeight: 600,
                }}
              >
                Add Bank Details
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default DashboardPage;
